export default "__VITE_ASSET__Cq5iN8sn__"